module.exports = __webpack_public_path__ + "img/144.4.0ffa67e1.png";